export enum Site {
  VISIONEXPRESS = 'Vission Express',
  TRENDYOPTICIANS = 'Trendy Opticians',
  GRANDOPTICAL = 'Grand Optical'
}
